export default __webpack_public_path__ + "static/media/unchecked-icon.6bf73171.svg";